import * as React from "react";
import ReactDOM from "react-dom";
import Routes from "./route";

ReactDOM.render(<Routes />, document.getElementById("app"));
